/* Behaviour for the home page sections (sections/zvh-*.liquid).
   Each section root carries data-zvh="<name>"; the matching function below
   wires it up once. Re-runs when the theme editor reloads a section. */
(function () {
  if (window.__zvhHome) return;
  window.__zvhHome = 1;

  var MOBILE = '(max-width: 749px)';
  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function isMobile() { return window.matchMedia(MOBILE).matches; }
  function reducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* Marks the child nearest the middle of a swipe row with .is-on. */
  function centreActive(row) {
    function update() {
      var mid = row.scrollLeft + row.clientWidth / 2, best = 0, bestDist = 1e9;
      Array.prototype.forEach.call(row.children, function (c, i) {
        var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      Array.prototype.forEach.call(row.children, function (c, i) { c.classList.toggle('is-on', i === best); });
    }
    row.addEventListener('scroll', update, { passive: true });
    update();
  }

  var INIT = {};

  /* ---- hero: cross-fading slides, dots, text tone per slide ---- */
  INIT.hero = function (root) {
    var slides = qa(root, '.zvh-hero__slide'), fades = qa(root, '.zvh-hero__fade'), dots = qa(root, '.zvh-hero__dot');
    var links = qa(root, '.zvh-hero__link');
    /* the sale slide (snippets/zvh-sale-slide.liquid) leaves once its end has passed, even from a cached page */
    var k0 = slides.findIndex(function (s) { return s.hasAttribute('data-sale'); });
    if (k0 > -1 && +slides[k0].getAttribute('data-end') && Date.now() > +slides[k0].getAttribute('data-end')) {
      [slides, fades, dots, links].forEach(function (set) { if (set[k0]) { set[k0].parentNode.removeChild(set[k0]); set.splice(k0, 1); } });
      if (dots.length < 2 && dots[0]) dots[0].parentNode.style.display = 'none';
    }
    var n = slides.length, cur = 0, timer;
    if (!n) return;
    function go(i) {
      cur = (i + n) % n;
      [slides, fades, dots, links].forEach(function (set) {
        set.forEach(function (el, k) { el.classList.toggle('is-on', k === cur); });
      });
      root.classList.toggle('is-light-d', slides[cur].getAttribute('data-tone-d') === 'light');
      root.classList.toggle('is-light-m', slides[cur].getAttribute('data-tone-m') === 'light');
      root.classList.toggle('is-sale', slides[cur].hasAttribute('data-sale'));
    }
    function restart() {
      clearInterval(timer);
      if (n < 2 || reducedMotion()) return;
      var secs = parseFloat(root.getAttribute('data-interval')) || 5;
      timer = setInterval(function () { go(cur + 1); }, secs * 1000);
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); restart(); }); });
    /* theme editor: show the slide being edited and hold it */
    root.addEventListener('shopify:block:select', function (e) {
      var k = slides.indexOf(e.target);
      if (k > -1) { go(k); clearInterval(timer); }
    });
    root.addEventListener('shopify:block:deselect', restart);
    go(0);
    restart();
  };

  /* ---- numbers: on phones the tile in the middle of the screen lifts ---- */
  INIT.trust = function (root) {
    var tiles = qa(root, '.zvh-stat');
    if (!tiles.length) return;
    function setOn(t) { tiles.forEach(function (x) { x.classList.toggle('is-on', x === t); }); }
    function update() {
      if (!isMobile()) return;
      var mid = window.innerHeight / 2, best = null, bestDist = 1e9;
      tiles.forEach(function (t) {
        var b = t.getBoundingClientRect();
        if (b.bottom < 0 || b.top > window.innerHeight) return;
        var d = Math.abs(b.top + b.height / 2 - mid);
        if (d < bestDist && d < b.height / 2 + 40) { bestDist = d; best = t; }
      });
      setOn(best);
    }
    window.addEventListener('scroll', update, { passive: true });
    tiles.forEach(function (t) { t.addEventListener('click', function () { if (isMobile()) setOn(t); }); });
    update();
    trustReveal(root, tiles);
  };

  /* Numbers: each tile rises in as it scrolls into view and its number
     counts up from zero. Skipped when the visitor asks for less motion. */
  function trustReveal(root, tiles) {
    if (reducedMotion() || !('IntersectionObserver' in window)) return;
    var counts = tiles.map(function (t) {
      var node = (t.querySelector('.zvh-stat__num') || {}).firstChild;
      if (!node || node.nodeType !== 3) return null;
      var text = node.nodeValue.trim(), end = parseInt(text.replace(/,/g, ''), 10);
      if (!/^[\d,]+$/.test(text) || !end) return null;
      node.nodeValue = '0';
      return { node: node, text: text, end: end, grouped: text.indexOf(',') > -1 };
    });
    function count(c, delay) {
      var start = null, DUR = 1600;
      function step(now) {
        if (start === null) start = now + delay;
        var p = Math.min(Math.max((now - start) / DUR, 0), 1);
        var v = Math.round(c.end * (1 - Math.pow(1 - p, 3)));
        c.node.nodeValue = p === 1 ? c.text : (c.grouped ? v.toLocaleString('en-IN') : String(v));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var i = tiles.indexOf(e.target), delay = isMobile() ? 0 : i * 110;
        e.target.style.setProperty('--d', delay + 'ms');
        e.target.classList.add('is-in');
        if (counts[i]) count(counts[i], delay + 150);
      });
    }, { threshold: 0.25 });
    root.classList.add('is-armed');
    tiles.forEach(function (t) { io.observe(t); });
  }

  /* ---- series: the family under the pointer (or the tapped tab) shows ---- */
  INIT.series = function (root) {
    var rows = qa(root, '.zvh-series__row'), tabs = qa(root, '.zvh-series__tabs button');
    var sets = [rows, tabs, qa(root, '.zvh-series__shot'), qa(root, '.zvh-series__cap'), qa(root, '.zvh-series__explore')];
    var thumb = root.querySelector('.zvh-series__tabs');
    function set(i) {
      sets.forEach(function (els) { els.forEach(function (el, k) { el.classList.toggle('is-on', k === i); }); });
      if (thumb) thumb.style.setProperty('--i', i);
    }
    rows.forEach(function (r, k) {
      r.addEventListener('mouseenter', function () { set(k); });
      r.addEventListener('focus', function () { set(k); });
    });
    tabs.forEach(function (b, k) { b.addEventListener('click', function () { set(k); }); });
    root.addEventListener('shopify:block:select', function (e) {
      var k = rows.indexOf(e.target);
      if (k > -1) set(k);
    });
    set(0);
  };

  /* ---- clients: the video under the pointer comes forward, the rest dim;
     on phones it is the card in the middle of the swipe row ---- */
  INIT.clients = function (root) {
    var row = root.querySelector('.zvh-clients__row');
    if (!row) return;
    var cards = qa(row, '.zvh-video');
    function setOn(card) {
      cards.forEach(function (c) { c.classList.toggle('is-on', c === card); });
      row.classList.toggle('has-on', !!card);
    }
    cards.forEach(function (c) {
      c.addEventListener('mouseenter', function () { if (!isMobile()) setOn(c); });
    });
    row.addEventListener('mouseleave', function () { if (!isMobile()) setOn(null); });
    function swipe() {
      if (!isMobile()) return;
      var mid = row.scrollLeft + row.clientWidth / 2, best = null, bestDist = 1e9;
      cards.forEach(function (c) {
        var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid);
        if (d < bestDist) { bestDist = d; best = c; }
      });
      setOn(best);
    }
    row.addEventListener('scroll', swipe, { passive: true });
    window.addEventListener('resize', function () { if (isMobile()) swipe(); else setOn(null); });
    swipe();
  };

  /* ---- app: on phones the card in the middle of the swipe row is the big one ---- */
  INIT.app = function (root) {
    var row = root.querySelector('.zvh-app__cards');
    if (row) centreActive(row);
  };

  if (window.__zvhFinderInit) INIT.finder = window.__zvhFinderInit;

  function mount(scope) {
    qa(scope || document, '[data-zvh]').forEach(function (el) {
      var name = el.getAttribute('data-zvh');
      if (el.__zvhDone || !INIT[name]) return;
      el.__zvhDone = 1;
      try { INIT[name](el); } catch (e) { if (window.console) console.error('zvh ' + name, e); }
    });
  }
  window.ZVH = { init: INIT, mount: mount, qa: qa, isMobile: isMobile, reducedMotion: reducedMotion, centreActive: centreActive };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(); });
  else mount();
  document.addEventListener('shopify:section:load', function (e) { mount(e.target); });
})();
